
import { Component, Prop, Vue } from 'vue-property-decorator';
import vClickOutside from 'v-click-outside';
import { Languages, LocaleOption } from '@/logic/locale/Languages';

Vue.use(vClickOutside);

@Component
export default class SwitchLocale extends Vue {
  @Prop({ type: Array, required: false, default: () => [] })
  limitLanguages!: string[];

  locales = Languages.getLanguages();

  active = false;

  get currentLocale(): LocaleOption {
    const locale = this.locales.find((loc) => loc.id === this.$i18n.locale);
    return locale || this.locales[0];
  }

  getAvailableLanguages(): any {
    if (this.limitLanguages.length === 0) {
      return this.locales;
    }

    return this.locales.filter((lang) => this.limitLanguages.includes(lang.id));
  }

  toggle() {
    this.active = !this.active;
  }

  setLanguage(id: string) {
    this.$i18n.locale = id;
    this.active = false;
  }

  onClickOutside() {
    this.active = false;
  }
}
